import React, { PropsWithChildren } from 'react';

import DisplayTitle, { DisplayTitleTab } from 'components/Meteorology/Fields/DisplayTitle';

import './index.scss';

// Titulo da consulta com um espaco de acoes alinhado a direita, na mesma linha.
// Usado por Previsao Numerica e Dados Observados para ancorar o botao de
// download ao titulo em vez de deixa-lo solto numa toolbar acima.
export default function DisplayTitleBar({
  tab,
  children,
}: PropsWithChildren<{ tab: DisplayTitleTab }>) {
  return (
    <div className="display-title-bar">
      <DisplayTitle tab={tab} />
      {children && (
        <div className="display-title-bar__actions">
          {children}
        </div>
      )}
    </div>
  );
}
